export const artworkData = [
    {
        targetName: 'book-cover',
        file: '/TomBookRound3.glb',
        audio: '/audio.mp3?url',
    },
];
